/**
 * 分镜关键帧节点面板（P2-图像）。三段式外壳由 FloatingPanel 提供，内部生成控件复用共享的
 * ImageGenControls。额外给一个「在导演台打开」入口（关键帧双来源之一，用户 2026-10-02）。
 */
import type { CanvasNode, GenerationParams, MediaRef } from '../../model/canvas';
import { ImageGenControls } from './ImageGenControls';
import type { ImageEditOp } from './generationService';

interface ImageNodePanelProps {
  node: CanvasNode;
  generating: boolean;
  hasUpstream: boolean;
  onParams: (patch: Partial<GenerationParams>) => void;
  onGenerate: () => void;
  onOptimize: () => void;
  onCompose: () => void;
  onUpload: (file: File) => void;
  onPickVariant: (media: MediaRef) => void;
  onEdit: (op: ImageEditOp) => void;
  onReverse?: () => void;
  onUpscale?: () => void;
  onCrop?: (ratio: string) => void;
  onMultiView?: () => void;
  onRelight?: (preset: string) => void;
  onDraw?: () => void;
  onOpenInDirector?: () => void;
}

export function ImageNodePanel({ onOpenInDirector, ...rest }: ImageNodePanelProps) {
  return (
    <ImageGenControls
      {...rest}
      extraActions={
        onOpenInDirector ? (
          <>
            <span className="text-ink-faint">·</span>
            <button
              type="button"
              className="text-ink-secondary transition-colors hover:text-ink-primary hover:underline disabled:opacity-40"
              onClick={onOpenInDirector}
            >
              在导演台打开
            </button>
          </>
        ) : undefined
      }
    />
  );
}
